import { EnumObjectValue } from '@shared/utils/common/types';
import { ToastItem } from '@shared/ui/kit/toast/toast-item';
import { NotificationItem } from '@shared/ui/kit/notification/notification-item';

export type OverlayStackPlacementValue = EnumObjectValue<typeof OverlayStackPlacement>;
export const OverlayStackPlacement = {
  left: 'left',
  right: 'right',
  center: 'center'
} as const;

export type OverlayStackItemKindValue = EnumObjectValue<typeof OverlayStackItemKind>;
export const OverlayStackItemKind = {
  toast: 'toast',
  notification: 'notification'
} as const;

/**
 * Where each kind of message goes by default. Moving a whole kind somewhere else (say, notifications
 * back to the bottom-center) is a matter of changing its entry here.
 */
export const DEFAULT_PLACEMENT: Record<OverlayStackItemKindValue, OverlayStackPlacementValue> = {
  toast: OverlayStackPlacement.left,
  notification: OverlayStackPlacement.left
};

interface OverlayStackItemBase {
  id: string;
  placement: OverlayStackPlacementValue;
  /** Fades the item out this long after it is shown (or last updated). It stays until removed when omitted. */
  durationMs?: number;
}

/** A message in the shared bottom-of-screen stack: either a toast or a notification card. */
export type OverlayStackItem =
  | (OverlayStackItemBase & { kind: typeof OverlayStackItemKind.toast; toast: ToastItem })
  | (OverlayStackItemBase & { kind: typeof OverlayStackItemKind.notification; notification: NotificationItem });

/** An {@link OverlayStackItem} on screen, carrying the state the stack itself owns. */
export type RenderedOverlayStackItem = OverlayStackItem & {
  zIndex: number;
  /** Cleared just before removal so the fade-out animation gets to play. */
  isShown: boolean;
};
